export { LabResults } from './LabResults';
